<template>
  <div>
    <div class="font-weight-bold color-gray-7 mt-2 mb-3">
      Información de Localidad
    </div>
    <validation-provider :rules="!user.locations ? '' : `locationsRequired:1`
      " v-slot="{ errors: locationErrors }">
      <chips-selection ref="roleSelection" v-model="user.locations" @addingItem="add('userLocationEntry')"
        selected-items-title="Escuelas Seleccionadas:" items-title-class="ml-2" :errors="locationErrors"
        :chips-config="chipsConfig" :disabled="readonly">
        <template #selectionInputs>
          <validation-observer ref="userLocationEntry" disabled>

            <div class="form-group">
              <label class="field-label">Región</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down ref="regionsDdl" :options="regionOptions" fieldname="name" fieldkey="id"
                  placeholder="Seleccione" :error="errors[0]" custom-error-msg="Favor seleccione."
                  v-model="selectedRegion" @input="getMunicipalities"></custom-drop-down>
              </validation-provider>
            </div>

            <div class="form-group">
              <label class="field-label">Distrito</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down ref="distritoDdl" :options="districtOptions" fieldname="name" fieldkey="id"
                  placeholder="Seleccione" :error="errors[0]" custom-error-msg="Favor seleccione."
                  v-model="selectedDistrict"></custom-drop-down>
              </validation-provider>
            </div>

            <div class="form-group">
              <label class="field-label">Municipio</label>
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <custom-drop-down ref="municipalityDdl" :options="municipalityOptions" fieldname="name" fieldkey="id"
                  placeholder="Seleccione" :error="errors[0]" custom-error-msg="Favor seleccione."
                  v-model="selectedMunicipality"></custom-drop-down>
              </validation-provider>
            </div>

          </validation-observer>
        </template>
      </chips-selection>
    </validation-provider>

  </div>
</template>
<script>
import CustomDropDown from 'custom-drop-down';
import ChipsSelection from '@/components/common/ChipsSelection';
import {
  getUserLocations,
  getSipaeeDistricts,
  getSiPaeeRegions,
  getSipaeeMunicipalities,
} from '@/modules/users/api';


export default {
  name: 'SipaeeLocation',
  components: {
    CustomDropDown,
    ChipsSelection,
  },
  model: {
    prop: 'user',
    event: 'user-changed',
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },

  },
  data() {
    return {
      regionOptions: [],
      selectedRegion: null,
      districtOptions: [],
      selectedDistrict: null,
      municipalityOptions: [],
      selectedMunicipality: null,
      chipsConfig: [],
    };
  },
  async mounted() {
    await this.setupLocations();
  },
  methods: {
    async getMunicipalities() {
      this.municipalityOptions = await getSipaeeMunicipalities();
    },
    async setupLocations() {
      await this.getRegions();
      await this.getDistricts();
      await this.getUserLocations();
    },
    async getDistricts() {
      this.districtOptions = await getSipaeeDistricts();
    },
    async getRegions() {
      this.regionOptions = await getSiPaeeRegions();
    },
    async add(form) {
      const passed = await this.$refs[form].validate();
      if (passed) {
        this.$refs[form].reset();
        return this.locationData();
      }
    },
    locationData() {

      let result = {}

      result.regionId = this.selectedRegion.id;
      result.regionName = this.selectedRegion.name;

      this.selectedRegion = null;

      result.districtId = this.selectedDistrict.id;
      result.districtName = this.selectedDistrict.name;
      this.selectedDistrict = null;

      result.municipalityId = this.selectedMunicipality.id;
      result.municipalityName = this.selectedMunicipality.name;
      this.selectedMunicipality = null;

      this.chipsConfig = [
        { labelText: 'Región:', valueProp: 'regionName' },
        { labelText: 'Distrito:', valueProp: 'districtName' },
        { labelText: 'Municipio:', valueProp: 'municipalityName' },
      ];
      return result;
    },
    async validate() {
      return (await this.$refs.locationVP.validate()).valid;
    },
    async getUserLocations() {
      const response = await getUserLocations(this.user.userId);
      this.user.locations = response;
  
      this.chipsConfig = [
        { labelText: 'Región:', valueProp: 'regionName' },
        { labelText: 'Distrito:', valueProp: 'districtName' },
        { labelText: 'Municipio:', valueProp: 'municipalityName' },
      ];
    }
  },
};
</script>
